module.exports = __webpack_public_path__ + "static/media/YF100_4.db9d02a6.jpg";